// src/pages/servicos/tecnicos/TecnicoResponsavelSearch.js
import React, { useMemo, useState } from 'react';
import ModalBody from '../../../components/modalForm/ModalBody';
import ModalContainer from '../../../components/modalForm/ModalContainer';
import ModalFooter from '../../../components/modalForm/ModalFooter';
import ModalHeader from '../../../components/modalForm/ModalHeader';
import ModalTable from '../../../components/modalForm/ModalTable';
import LazyLoading from '../../../components/modalForm/LazyLoading';
import { useTecnicoResponsavel } from '../../../contexts/servicos/TecnicoResponsavelContext';
import ModalSearchBar from '../../../components/modalForm/ModalSearchBar';
import { ModalActionButton } from '../../../components/modalForm/ModalActions';
import ModalSelectButton from '../../../components/modalForm/ModalSelectButton';

const TecnicoResponsavelSearch = ({ show, onHide, onSelectTecnico }) => {
  const { tecnicos } = useTecnicoResponsavel();
  const [filtro, setFiltro] = useState('');
  const filtrados = useMemo(() => {
    const texto = filtro.trim().toLocaleLowerCase('pt-BR');
    if (!texto) return tecnicos;
    return tecnicos.filter(tecnico => [tecnico.id, tecnico.nome].some(
      valor => String(valor || '').toLocaleLowerCase('pt-BR').includes(texto),
    ));
  }, [tecnicos, filtro]);

  if (!show) return null;

  const selecionar = tecnico => {
    onSelectTecnico(tecnico);
    setFiltro('');
  };

  return (
    <ModalContainer show={show} zIndex={1060} variant="busca" onHide={onHide}>
      <ModalHeader title="Buscar técnico responsável" onHide={onHide} />
      <ModalBody>
        <ModalSearchBar

          placeholder="Filtrar por código ou nome..."
          value={filtro}
          onChange={evento => setFiltro(evento.target.value)}
          autoFocus
        />
        <LazyLoading items={filtrados} resetKey={JSON.stringify([show, filtro])}>
        {({ containerRef, handleScroll, visibleItems }) => (
        <ModalTable containerRef={containerRef} onContainerScroll={handleScroll}>
          <thead><tr><th>Código</th><th>Nome</th><th  className="modal-select-column"/></tr></thead>
          <tbody>
            {visibleItems.map(tecnico => (
              <tr key={tecnico.id} onDoubleClick={() => selecionar(tecnico)}>
                <td>{tecnico.id}</td>
                <td>{tecnico.nome}</td>
                <td className="text-end modal-select-column">
                  <ModalSelectButton type="button" className="btn btn-sm btn-outline-primary" onClick={() => selecionar(tecnico)} label={tecnico.nome} />
                </td>
              </tr>
            ))}
            {!filtrados.length && (
              <tr><td colSpan="3" className="text-center text-muted">Nenhum técnico encontrado.</td></tr>
            )}
          </tbody>
        </ModalTable>
        )}
        </LazyLoading>
      </ModalBody>
      <ModalFooter>
        <ModalActionButton type="button" className="btn btn-secondary" onClick={onHide} action="close">Fechar</ModalActionButton>
      </ModalFooter>
    </ModalContainer>
  );
};

export default TecnicoResponsavelSearch;
